module.exports = __webpack_public_path__ + "img/incognito.ef5170b9.webp";